import Checkbox from '@mui/material/Checkbox';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledCheckbox = styled.div`
  display: flex;
  align-items: center;
`;

export const BasicCheckbox = ({ value, name, color, sendValue, onChange, children }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e) => {
    if (!sendValue) return;

    const name = e.target.name;
    const checked = e.target.checked;

    if (onChange) {
      onChange(name, checked);
    }

    setIsChecked(checked);
    sendValue(e);
  };

  useEffect(() => {
    if (!value) {
      setIsChecked(false);
    } else {
      setIsChecked(value);
    }
  }, [value]);

  return (
    <StyledCheckbox className="checkbox">
      <Checkbox checked={value} onChange={handleChange} name={name} />
      {children}
    </StyledCheckbox>
  );
};
